import React, { useState, useRef, useEffect } from "react";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { ThemeProvider } from "@mui/material/styles";
import DownloadIcon from "@mui/icons-material/Download";
import QrCodeIcon from "@mui/icons-material/QrCode2";
import html2canvas from "html2canvas";
import { useTranslation } from "react-i18next";
import Flag from "react-world-flags"; // Bayrak kütüphanesini import et
import "./App.css"; //App.css
import "./i18n/i18n"; // i18n yapılandırmasını buraya ekle
import { theme } from "./themes/theme";

import {
  AppBar,
  Box,
  Toolbar,
  Button,
  Container,
  Card,
  CardContent,
  CardActions,
  Grid2 as Grid,
  Tooltip,
  TextField,
} from "@mui/material";

function App() {
  const [text, setText] = useState();
  const { t, i18n } = useTranslation(); // useTranslation hook'u ile çeviri fonksiyonunu al

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Dil değiştirme fonksiyonu
  };

  // Dil değiştiğinde title'ı güncellemek için useEffect kullanıyoruz
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]); // Dil değiştiğinde tetiklenir

  const qrRef = useRef(null); // QR kodunu referans olarak almak için

  const downloadQRCode = async () => {
    if (qrRef.current) {
      try {
        // QR kodunu canvas'a dönüştür
        const canvas = await html2canvas(qrRef.current, { scale: 2 });

        // PNG formatında veri URL'si oluştur
        const pngUrl = canvas.toDataURL("image/png");

        // Benzersiz dosya adı oluştur
        const uniqueId = Date.now(); // Zaman damgası kullanarak benzersiz bir ID oluştur

        // İndirme işlemi için bir link oluştur
        const link = document.createElement("a");
        link.href = pngUrl;
        link.download = `qrcode_${uniqueId}.png`; // Benzersiz ad
        link.click(); // İndirme işlemini başlat
      } catch (error) {
        console.error("QR kodu indirirken hata:", error);
      }
    }
  };

  const downloadQRCodeSVG = () => {
    const svgElement = document.getElementById("qrcode-svg");
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });

    const url = URL.createObjectURL(svgBlob);

    // Benzersiz dosya adı oluştur
    const uniqueId = Date.now(); // Zaman damgası kullanarak benzersiz bir ID oluştur

    const link = document.createElement("a");
    link.href = url;
    link.download = `qrcode_${uniqueId}.svg`;
    link.click();
  };

  const handleReload = () => {
    window.location.reload(); // Sayfayı yeniden yükler
  };

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static">
        <Toolbar>
          <QrCodeIcon />
          <Button color="inherit" onClick={handleReload}>
            {t("pageTitle")}
          </Button>
          <Tooltip title="English" arrow>
            <Button
              size="small"
              color="inherit"
              onClick={() => changeLanguage("en")}
              style={{ marginLeft: "auto" }}
              startIcon={
                <Flag code="GB" style={{ width: "20px", height: "20px" }} />
              }
            ></Button>
          </Tooltip>
          <Tooltip title="Türkçe" arrow>
            <Button
              className={i18n.language === "tr" ? "active" : ""}
              size="small"
              color="inherit"
              onClick={() => changeLanguage("tr")}
              startIcon={
                <Flag code="TR" style={{ width: "20px", height: "20px" }} />
              }
            ></Button>
          </Tooltip>

          {/* <Button color="inherit">{t("login")}</Button>
          <Button color="inherit">{t("register")}</Button> */}
        </Toolbar>
      </AppBar>

      <Container style={{ marginTop: "20px" }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid size={8} xs={8}>
              <Card className="Card">
                <CardContent>
                  <TextField
                    value={text}
                    placeholder={t("placeHolderText")}
                    onChange={(e) => setText(e.target.value)}
                    className="TextFieldArea"
                    rows={3}
                    multiline
                    fullWidth
                    sx={{
                      width: "%100",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none", // Kenarlığı kaldır
                        },
                        "&:hover fieldset": {
                          border: "none", // Hover durumunda kenarlığı kaldır
                        },
                        "&.Mui-focused fieldset": {
                          border: "none", // Focus durumunda kenarlığı kaldır
                        },
                        "& input": {
                          textAlign: "center", // Yatayda ortala
                          display: "flex",
                          alignItems: "center", // Dikeyde ortala
                          height: "100%", // Dikey ortalamayı sağlamak için yüksekliği ayarla
                          justifyContent: "center", // Dikey ortalamayı sağlamak için
                        },
                      },
                    }}
                  />
                </CardContent>
                <CardActions
                  style={{
                    textAlign: "justify",
                    display: "flex",
                    alignItems: "right",
                    height: "100%",
                    justifyContent: "flex-end",
                  }}
                >
                  {/* <Button size="small" variant="inherit">
                    <UploadFileIcon />
                    {t("uploadButtonText")}
                  </Button> */}
                </CardActions>
              </Card>
            </Grid>
            <Grid size={4} xs={4}>
              <Card
                variant="outlined"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CardContent ref={qrRef}>
                  <QRCodeCanvas value={text} size={256} />
                  <QRCodeSVG
                    id="qrcode-svg"
                    value={text}
                    size={256}
                    style={{ display: "none" }}
                  />
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={downloadQRCode}
                  >
                    <DownloadIcon /> {t("downloadPng")}
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={downloadQRCodeSVG}
                  >
                    <DownloadIcon /> {t("downloadSVG")}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default App;
